import { useState } from "react";
import { motion } from "framer-motion";
import { Input } from "@/components/ui/input";
import { Lock, ArrowRight } from "lucide-react";

const PASSCODE = "ECH2026";

export default function PasswordGate({ children }) {
  const [unlocked, setUnlocked] = useState(() => sessionStorage.getItem("ech_gate") === "1");
  const [value, setValue] = useState("");
  const [error, setError] = useState(false);

  if (unlocked) return children;

  const submit = (e) => {
    e.preventDefault();
    if (value.trim() === PASSCODE) {
      sessionStorage.setItem("ech_gate", "1");
      setUnlocked(true);
    } else {
      setError(true);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0D14] flex items-center justify-center px-6 relative overflow-hidden" data-testid="password-gate">
      <div className="absolute left-1/3 top-1/3 w-[500px] h-[500px] rounded-full bg-emerald-500/20 blur-3xl opacity-20 pointer-events-none" />
      <div className="grain-overlay" />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        className="relative w-full max-w-md rounded-xl border border-white/10 bg-[#121722] p-10"
      >
        <div className="flex items-baseline gap-1 mb-8">
          <span className="font-serif-display text-2xl font-bold tracking-tight text-slate-50">ECH</span>
          <span className="text-[10px] uppercase tracking-[0.25em] text-emerald-400 font-semibold">IDR</span>
        </div>
        <span className="flex items-center justify-center w-12 h-12 rounded-full border border-emerald-500/40 bg-emerald-500/10 mb-6">
          <Lock className="w-5 h-5 text-emerald-400" />
        </span>
        <h1 className="font-serif-display text-2xl font-bold tracking-tight text-slate-50">Private access</h1>
        <p className="mt-2 text-sm text-slate-400">Enter the access code to view the calculator.</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <Input
            type="password"
            value={value}
            onChange={(e) => { setValue(e.target.value); setError(false); }}
            placeholder="Access code"
            autoFocus
            className="h-12 bg-[#0A0D14] border-white/10 text-slate-50 focus:ring-2 focus:ring-emerald-500/50"
            data-testid="gate-password-input"
          />
          {error && (
            <p className="text-xs text-red-400" data-testid="gate-error">Incorrect code. Try again.</p>
          )}
          <button
            type="submit"
            className="group w-full inline-flex items-center justify-center gap-2 rounded-full bg-emerald-500 text-[#0A0D14] px-6 py-3.5 text-sm font-bold uppercase tracking-[0.14em] hover:bg-emerald-400 transition-colors duration-200"
            data-testid="gate-submit-btn"
          >
            Enter
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </form>
      </motion.div>
    </div>
  );
}
